import styled, { css } from 'styled-components';

import { unselectedColor } from './colors';

export interface IActive {
  active?: boolean;
}

export interface ITabsStyle {
  tabWidth?: 'fill' | 'content' | 'flex';
}

interface IColorable {
  color?: 'primary' | 'secondary' | 'inverted';
  inactiveStyle?: { [key: string]: string | number };
}

interface IDisableable {
  disabled?: boolean;
}

export const getColor = (
  color?: 'primary' | 'secondary' | 'inverted',
  active?: boolean,
  disabled?: boolean
): string => {
  if (disabled) {
    if (color === 'inverted') {
      return 'rgba(255, 255, 255, 0.5)';
    }
    return 'rgba(0, 0, 0, 0.5)';
  }
  if (active) {
    if (color === 'inverted') {
      return Styles.color.white;
    }
    if (color === 'secondary') {
      return Styles.color.accent;
    }
    return Styles.color.black;
  }
  // inactive
  if (color === 'inverted') {
    return Styles.color.white;
  }
  if (color === 'secondary') {
    return Styles.color.accent;
  }
  return unselectedColor;
};

const getBorder = (
  color?: 'primary' | 'secondary' | 'inverted',
  active?: boolean,
  disabled?: boolean
): string => {
  if (!active || disabled) {
    return 'transparent';
  }
  if (active) {
    if (color === 'inverted') {
      return Styles.color.white;
    }
    return Styles.color.primary;
  }
  return 'transparent';
};

const tabWidthFillCss = css`
  margin: 0;
  padding: 1rem 0;
`;
const tabWidthContentCss = css`
  margin: 1.5rem 2rem 0.5rem 0;
  padding: 0;

  &:last-child {
    margin-right: 0;
  }
`;
const tabWidthFlexCss = css`
  margin: 1.5rem 0 0.5rem;
  padding: 0;
`;

export const TabStyle = styled.button<IActive & IColorable & IDisableable & ITabsStyle>`
  float: left;
  width: ${p => (p.tabWidth === 'fill' ? '100%' : 'auto')};
  font-weight: ${p => (p.color === 'inverted' ? 400 : Styles.fontWeight.heavy)};
  font-size: 1rem;
  color: ${p => getColor(p.color, p.active, p.disabled)};
  list-style-type: none;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  transition: transform 200ms ease-out;
  border-bottom-color: ${p => getBorder(p.color, p.active, p.disabled)};
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  font-family: ${Styles.fontFamily.base};
  ${p => !p.active && p.inactiveStyle}
  ${p => {
    if (p.tabWidth === 'fill') {
      return tabWidthFillCss;
    }
    if (p.tabWidth === 'flex') {
      return tabWidthFlexCss;
    }
    return tabWidthContentCss;
  }}
`;

export const SlidingUnderline = styled.div<IColorable & { tabSlideWidth: number; idx: number }>`
  height: 2px;
  width: ${p => `${p.tabSlideWidth}px`};
  background-color: ${p => getColor(p.color)};
  transform: ${p => `translateX(${p.tabSlideWidth * p.idx}px)`};
  transition: 0.3s;
`;
